module.exports = __webpack_public_path__ + "static/media/credit_card.92338b1f.png";